<template>
    <div id="services-page">
        <div class="page-heading hide-on-small">
            <h2 class="display-4 montserrat-bold mb-0">Shop Services & Packages</h2>
            <div class="mt--2 heading-small">Services and packages that are available</div>
        </div>
    
        <div class="search-bar-container">
            <i class="fas fa-search icon"></i>
            <input type="text" placeholder="Search" class="search-bar" v-model="serviceParams.search" @keyup.enter="$refs.list.refresh()">
        </div>

        <div class="bg-white shadow-reg list-container">
            <div class="table-navbar"> 
                <a :class="['table-navbar-item', isTypeActive('all') && 'active']" href="all" @click.prevent="setTypeFilter('all')">All</a>
                <a :class="['table-navbar-item', isTypeActive('service') && 'active']" href="services" @click.prevent="setTypeFilter('service')">Services</a>
                <a :class="['table-navbar-item', isTypeActive('package') && 'active']" href="packages" @click.prevent="setTypeFilter('package')">Packages</a>
            </div>
            <div class="list-wrapper">
                <paginated-section v-if="serviceFetchLink" :fetch-link="serviceFetchLink" :params="serviceParams" paginate-path="data.result.services" ref="list" simplified>
                    <template slot="loading">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">
                            <i class="fas fa-spin fa-spinner mr-2"></i> Loading services
                        </h3>
                    </template>
                    <template slot="empty">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">No services were found</h3>
                    </template>
                    <template slot="body" slot-scope="{ record }">
                        <service-list-item :service="record" @show="showService" />
                    </template>
                </paginated-section>
            </div>
        </div>

        <service-modal ref="serviceModal" />

    </div>
</template> 
<script>
import '@styles/table.css';
import ServiceListItem from "./ServiceListItem";
import ServiceModal from "./ServiceModal";
import { route } from "@utils/network";

export default {
    name: "ServicesPage",

    components: { ServiceListItem, ServiceModal },

    data: () => ({
        loading: false,
        shop: {},
        serviceFetchLink: null,
        serviceParams: {
            search: "",
            type: "all"
        },
    }),

    methods: {
        initialize(shop) {
            this.shop = shop;
            this.serviceFetchLink = route("shops/:id/services-and-packages", { id: shop.id });
        },
        setTypeFilter(type) {
            this.serviceParams.type = type;
            this.$refs.list.refresh();
        },
        isTypeActive(type) {
            return this.serviceParams.type == type;
        },
        showService(service) {
            return this.$refs.serviceModal.show(service);
        },
    },

    mounted() {
        this.$emit("mounted");
    }
}
</script>